var CompanySize = {
	"Company size": "Размер компании",
	"1-19 employees": "1-19 сотрудников",
	"20-99 employees": "20-99 сотрудников",
	"100-499 employees": "100-499 сотрудников",
	"500-999 employees": "500-999 сотрудников",
	"1,000-9,999 employees": "1000-9999 сотрудников",
	"10,000 employees or more": "10 000 и более сотрудников"
};

export { CompanySize as default };
